



















































































































































































































































































































































































































































import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator'
import SeletorDeCliente from '../clientes/SeletorDeCliente.vue';
import SeletorDeLojasDoUsuario from '@/components/loja/SeletorDeLojasDoUsuario.vue';
import { obrigatorio } from '@/shareds/regras-de-form';
import { FormaDePagamento, PontoDeVendaComTurno, Titulo, Usuario } from '@/models';
import { dateToPtBrFormat } from '@/shareds/date/date-utils';
import { FindTituloUseCase } from '@/usecases/titulos/FindTituloUseCase';
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore';
import { FormDeFiltroDeTitulos } from './NovaTelaDeTitulos.vue';
import AlertModule from '@/store/vuex/aplicacao/AlertModule';
import CheckboxButton from '@/components/ui/CheckboxButton.vue';
import { CreateBaixaDePagamentoUseCase, FindBaixaDePagamentoUseCase } from '@/usecases';
import { BaixaDePagamentoMultiploForm, TipoDeTransacaoDaBaixaDePagamento } from '@/models/financeiro/BaixaDePagamento';
import moment from 'moment';
import { imprimirComprovanteDeRecebivel } from "@/shareds/venda-shareds"
import CampoDecimal from '@/components/ui/CampoDecimal.vue';
import { formatarMoeda } from '@/shareds/formatadores';
import { DataOptions } from 'vuetify';
import { FindPdvUseCase } from '@/usecases/pdv/FindPdvUseCase';
import { somarSaldoDosTitulosSelecionados, tituloTemSaldoAPagar, validarValorDoPagamentoEmMassa } from '@/shareds/titulo-shareds';
import { apurarEncargosDoTitulo, baixasParaEncargos } from '@/shareds/encargos-do-titulo';
import DatePicker from '@/components/ui/DatePicker.vue';
import SeletorDeAdquirente from '@/views/application/venda/SeletorDeAdquirente.vue'

const FILTRO_DE_TITULOS = 'FILTRO_DE_TITULOS'

	@Component({
		components: {
			SeletorDeCliente,
			SeletorDeLojasDoUsuario,
			CheckboxButton,
			CampoDecimal,
			DatePicker,
			SeletorDeAdquirente,
		},
	})
export default class DialogoDePagamentoEmMassaDeTitulos extends Vue {
	// Armadilha: `carregando` e prop e mesmo assim buscar() escreve nela
	// (this.carregando = true/false). Alem do aviso do Vue por mutar prop, o valor volta ao da
	// prop a cada re-render do pai, e isso nao e cosmetico: calcularValorFaltante so apura juros
	// e multa quando this.carregando === false. Mexer aqui muda o numero que aparece na grid. O
	// motivo de ser prop em vez de campo nao esta claro.
	@Prop({ type: Boolean, default: false }) carregando!: boolean
	@Ref() form!: HTMLFormElement
	@Ref() campoDeValorAPagar?: { validate: () => boolean }

	mostra: boolean | null = null
	lojaId: string | null = null
	usuario: Usuario | null = null
	valor: number | null = null
	formaDePagamento = ''
	formaDePagamamentoParaPagar = null
	titulosSelecionados: DialogoDePagamentoEmMassaDeTitulos['titulosFormatados'] = []
	titulos: Titulo[] = []
	titulosCache: Record<string, Titulo> = {}
	totalRegistros = -1
	pdvOptions: PontoDeVendaComTurno[] = []
	data = ''
	salvando = false
	idsDeTitulosSelecionados: string[] = []
	tipoDePessoa: 'cliente' | 'adquirente' = 'cliente'
	clienteAdquirente: string | null = null
	titulosFiltradoDaTelaPrincipal = false

	findTituloUseCase = new FindTituloUseCase()
	createBaixaUseCase = new CreateBaixaDePagamentoUseCase()
	findPdvUseCase = new FindPdvUseCase()
	findBaixaDePagamentoUseCase = new FindBaixaDePagamentoUseCase()

	obrigatorio = obrigatorio

	paginacao: DataOptions = {
		page: 0,
		itemsPerPage: 50,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}

	tipoDeDesconto: 'valorFixo' | 'porcentagem' = 'valorFixo'
	baixaDePagamento: BaixaDePagamentoMultiploForm = this.obterBaixaDePagamentoInicial()
	valorDeDescontoNosJuros: number | null = 0
	valorDeDescontoNaMulta: number | null = 0
	valorDeDescontoNosJurosEmPorcentagem = 0
	valorDeDescontoNaMultaEmPorcentagem = 0


	filtros: FormDeFiltroDeTitulos = this.obterFiltrosDeTitulosIniciais()
	
	headers = [
		{ text: 'Loja', value: 'loja', width: '18%' },
		{ text: 'Série', value: 'serie', width: '2%' },
		{ text: 'Número', value: 'numero', width: '2%' },
		{ text: 'Parcela', value: 'sequencia', width: '2%' },
		{ text: 'Descrição', value: 'descricao', width: '20%' },
		{ text: 'Competência', value: 'dataDeCompetencia', width: '10%' },
		{ text: 'Vencimento', value: 'dataDeVencimento', width: '10%' },
		{ text: 'Data Pagamento', value: 'dataPagamento', width: '10%' },
		{ text: 'Cliente', value: 'pessoa', width: '20%' },
		{ text: 'Valor', value: 'valor', width: '12%', align: 'right' },
		{ text: 'Valor Atualizado', value: 'valorAtualizado', width: '12%', sortable: false,  align: 'right' },
		{ text: 'Juros e Multa', value: 'totalEncargos', width: '10%', sortable: false,  align: 'right' },
		{ text: 'Forma de pagamento', value: 'formaDePagamento', width: '8%' },
	]

	opcoesDeFormaDePagamentoParaBusca: FormaDePagamento[] = [
		'Dinheiro',
		'Cartão',
		'Voucher',
		'Crediário',
		'TEF Crédito',
		'TEF Débito',
		'TEF Pix',
		'Link',
		'Outros',
		'Cheque',
		'Pix',
		'Boleto',
	]

	opcoesDeFormaDePagamento: FormaDePagamento[] = [
		'Dinheiro',
		'Cartão',
		'Pix',
		'Cheque',
		'Permuta',
	]

	/**
	 * Diz se o título entra no pagamento. O saldo gravado sozinho não basta: ele só é refeito no
	 * recálculo diário, e até lá a parcela quitada na carência ainda aparecia com o resíduo
	 * antigo, somava no total a cobrar e era pulada na confirmação, ou seja, o operador recebia
	 * um valor sem baixa correspondente (retorno de QA do 42385). Por isso o crediário também é
	 * apurado pela regra atual, na data do pagamento, com as baixas já carregadas.
	 */
	tituloPagavel(titulo: Titulo): boolean {
		if (!tituloTemSaldoAPagar(titulo)) return false
		if (titulo.formaDePagamento !== 'CREDIARIO' || titulo.fluxo !== 'Entrada') return true

		const apurado = apurarEncargosDoTitulo(
			titulo,
			baixasParaEncargos(titulo.baixaDePagamentoAuditada),
			this.data || moment().tz('America/Sao_Paulo').format('YYYY-MM-DD'),
			titulo.loja?.configuracaoDaLoja?.calcularJurosComMulta || false,
		)
		return !apurado || apurado.valorAtualizado > 0
	}

	calcularValorFaltante(titulo: Titulo): Titulo {
		if (
			titulo.formaDePagamento === "CREDIARIO" &&
			titulo.fluxo === 'Entrada' && 
			this.carregando === false
		) {
			// Mesma conta do backend (MotorDeEncargosDoTitulo), que é quem grava o título depois da
			// baixa: o pagamento quita primeiro multa e juros, e os encargos correm só sobre o que
			// falta pagar, período a período entre as baixas. Até o ticket 42385 esta tela calculava
			// sobre o valor cheio da parcela e ainda puxava o saldo gravado (Math.max com
			// valorAtualizado), que trazia de volta o resíduo de encargos de título já quitado.
			const apurado = apurarEncargosDoTitulo(
				titulo,
				baixasParaEncargos(titulo.baixaDePagamentoAuditada),
				this.data,
				titulo.loja?.configuracaoDaLoja?.calcularJurosComMulta || false,
			)

			if (!apurado) {
				titulo.valorRecalculado = titulo.valorAtualizado
				return titulo
			}

			titulo.jurosRecalculado = apurado.juros
			titulo.multaRecalculado = apurado.multa
			titulo.valorRecalculado = apurado.valorAtualizado

			return titulo
		}else{
			titulo.valorRecalculado = titulo.valorAtualizado
		}

		return titulo
	}

	isDataDePagamentoValida() {
		const listaDeTitulosInvalidos: string[] = []
		this.titulosSelecionados.forEach(titulo => {
			if (!this.ehDataValidaParaLiberacao(this.data, titulo)) {
				listaDeTitulosInvalidos.push(`${titulo.numero}/${titulo.sequencia}`)
			}
		})

		if(listaDeTitulosInvalidos.length > 0 ) {
			return `Data de pagamento inválida para os títulos selecionados`
		}

		return true
	}

	ehDataValidaParaLiberacao(data: string, titulo: any) {
		if (!data || !titulo?.dataDeCompetencia) return false;

		const dataSelecionada = moment(data).format('YYYY-MM-DD')
		const dataDeCompetencia = moment(titulo.dataDeCompetencia, 'DD/MM/YYYY').format('YYYY-MM-DD')
		
		return dataSelecionada < dataDeCompetencia ?
			false : true
	}

	@Watch('data')
	setDataPagamentoNosTitulos() {
		if (!this.data) return

		if (new Date(this.data).getTime() > Date.now()) {
			this.data = new Date().toISOString().substring(0, 10);
			AlertModule.setError('A data não pode ser maior que a data atual');
			return;
		}

		this.titulosSelecionados = this.titulosSelecionados.map(tituloSelecionado => {
			// O cache, e não a página atual: a grid é paginada no servidor e a seleção sobrevive à
			// troca de página. Procurando só em this.titulos, o título marcado numa página anterior
			// não era recalculado e ficava somando no Saldo Devedor com o valor de HOJE enquanto o
			// pagamento era gravado com a data retroativa, que é o defeito do 39094.
			const tituloOriginal = this.titulosCache[tituloSelecionado.id]
				?? this.titulos.find(t => t.id === tituloSelecionado.id)
			if (!tituloOriginal) return tituloSelecionado

			const tituloAtualizado = this.calcularValorFaltante(tituloOriginal)

			return {
				...tituloSelecionado,
				dataPagamento: this.data,
				valorAtualizado: tituloAtualizado.valorRecalculado?.toLocaleString('pt-br', {
					style: 'currency',
					currency: 'BRL',
				}) || '',
				juros: tituloAtualizado.jurosRecalculado?.toLocaleString('pt-br', {
					style: 'currency',
					currency: 'BRL',
				}) || '',
				multa: tituloAtualizado.multaRecalculado?.toLocaleString('pt-br', {
					style: 'currency',
					currency: 'BRL',
				}) || '',
			}
		})
	}

	// O Vuetify só reexecuta as :rules quando o próprio campo muda. Sem isto, quem digitou o valor
	// e só depois mexeu na data ou na seleção continuaria vendo o campo válido com um teto que já
	// não existe mais, e só descobriria no clique de Efetuar Pagamento.
	@Watch('saldoDosTitulosSelecionados')
	revalidarValorAPagar() {
		if (!this.valor) return
		this.$nextTick(() => this.campoDeValorAPagar?.validate())
	}

	@Watch('titulosFormatados', { deep: true })
	atualizarOsTitulosSelecionados() {

		this.titulosSelecionados.forEach(tituloSelecionado => {
			const titulo = this.titulosFormatados.find(titulo => titulo.id === tituloSelecionado.id)
			if (titulo) {
				tituloSelecionado.valorAtualizado = titulo.valorAtualizado
				tituloSelecionado.juros = titulo.juros
				tituloSelecionado.multa = titulo.multa
			}
		})
	}


	mostrar(titulos: Titulo[] = []) {
		// Isto sobrescreve o `filtros` inicial com o que estiver no localStorage, e a chave nao
		// existe enquanto ninguem tiver filtrado na tela de titulos. Antes as linhas seguintes
		// liam this.filtros.loja direto do null, e o dialogo nao abria pelo botao.
		this.filtros = JSON.parse(localStorage[FILTRO_DE_TITULOS] ?? 'null')
			?? this.obterFiltrosDeTitulosIniciais()
		this.data = moment().tz('America/Sao_Paulo').format('YYYY-MM-DD');
		this.mostra = true
		this.lojaId = this.filtros.loja
		this.formaDePagamento = this.filtros.formaDePagamento || ''
		this.usuario = this.filtros.pessoa	
		if(titulos){
			this.titulos = titulos
			this.titulosFiltradoDaTelaPrincipal = true
			titulos.forEach(titulo => { this.titulosCache[titulo.id] = titulo })
			this.$nextTick(() => {
				this.selecionarVencidos()
			})
		}
	}

	esconder() {
		this.mostra = false
		this.salvando = false
		this.lojaId = null
		this.usuario = null
		this.valor = null
		this.formaDePagamento = ''
		this.formaDePagamamentoParaPagar = null
		this.titulos = []
		this.titulosCache = {}
		this.totalRegistros = -1
		this.pdvOptions = []
		this.data = ''
		this.baixaDePagamento = this.obterBaixaDePagamentoInicial()
		this.limparFiltros()
		this.limparSelecao()
	}

	limparFiltros() {
		this.lojaId = null;
		this.formaDePagamento = ''
		this.usuario = null;
		this.formaDePagamamentoParaPagar = null;
		this.valor = null;
		this.titulosSelecionados = [];
		this.limparDescontos()
		this.limparSelecao()
	}

	displayPagamento(formaDePagamento: string) {
		let formaFormatada
		if (formaDePagamento == 'CARTAO') formaFormatada = 'Cartão'
		if (formaDePagamento == 'DINHEIRO') formaFormatada = 'Dinheiro'
		if (formaDePagamento == 'VOUCHER') formaFormatada = 'Voucher'
		if (formaDePagamento == 'OUTROS') formaFormatada = 'Outros'
		if (formaDePagamento == 'TEF CREDITO') formaFormatada = 'TEF Crédito'
		if (formaDePagamento == 'TEF DEBITO') formaFormatada = 'TEF Débito'
		if (formaDePagamento == 'CREDIARIO') formaFormatada = 'Crediário'
		if (formaDePagamento == 'LINK') formaFormatada = 'Link'
		if (formaDePagamento == 'CHEQUE') formaFormatada = 'Cheque'
		if (formaDePagamento == 'PIX') formaFormatada = 'Pix'
		if (formaDePagamento == 'BOLETO') formaFormatada = 'Boleto'
		if (formaDePagamento == 'PERMUTA') formaFormatada = 'Permuta'
		return formaFormatada
	}

	
	obterFiltrosDeTitulosIniciais(): FormDeFiltroDeTitulos {
		return {
			pessoa: null,
			tipoDeCliente: null,
			dataInicioPeriodo: null,
			dataFimPeriodo: null,
			situacaoDoTitulo: null,
			formaDePagamento: null,
			loja: null,
			numeroDocumento: null,
			dataInicioPagamento: null,
			dataFimPagamento: null,
			fluxo: null,
			numeroDoCheque: null,
			clienteAdquirente: null,
			somenteComValorDesatualizado: false,
			somenteComErroDeRecalculo: false,
		}
	}

	// Mesmo objeto literal existia em dois lugares (inicializacao do campo e esconder()).
	// tipoDeDesconto continua sendo lido de this: era assim nos dois lugares, e o campo e
	// declarado antes de baixaDePagamento, entao no momento da inicializacao ja vale valorFixo.
	obterBaixaDePagamentoInicial(): BaixaDePagamentoMultiploForm {
		return {
			titulo: null,
			transactionId: '',
			valorPagamento: 0,
			valorTaxa: 0,
			dataHoraPagamento: '',
			isTaxa: false,
			isIntegracao: false,
			formaDePagamento: null,
			turnoDeVendaId: null,
			valorJurosSobreBaixa: 0,
			valorDaMultaSobreBaixa: 0,
			tipoDeTransacao: null,
			valorDeDescontoNosJuros: 0,
			valorDeDescontoNaMulta: 0,
			tipoDeDesconto: this.tipoDeDesconto,
		}
	}

	onPdvChange(selectedPdvId) {
		this.baixaDePagamento.turnoDeVendaId = selectedPdvId;
	}

	preencherPdvAutomatico() {
		const turnoDeVenda = JSON.parse(localStorage.getItem('TURNO_DE_VENDA_STORAGE') || 'null');

		if (turnoDeVenda && turnoDeVenda.pontoDeVenda) {
			const pdv = {
				turnoDeVendaId: turnoDeVenda.id,
				nomePontoDeVenda: turnoDeVenda.pontoDeVenda.nome,
			};

			if (!this.pdvOptions.some(p => p.turnoDeVendaId === pdv.turnoDeVendaId)) {
				this.pdvOptions = [pdv, ...this.pdvOptions];
			}

			if (!this.baixaDePagamento.turnoDeVendaId) {
				this.baixaDePagamento.turnoDeVendaId = pdv.turnoDeVendaId;
			}
		}
	}


	async buscarPdvAberto() {			
		if (!this.titulos || this.titulos.length === 0 || !this.titulos[0].loja) return;
		const lojaId = this.titulos[0].loja.id;
		const pdvs = await this.findPdvUseCase.buscarPdvSemTurno(lojaId);
		this.pdvOptions = [...this.pdvOptions, ...pdvs];
	}

	valorMenorQueTotal(v) {
		// O teto é o saldo já líquido do que foi perdoado: o desconto de juros e multa não
		// pode ser cobrado do cliente. Sem desconto nenhum, totalAPagarComDesconto é o próprio
		// saldo dos títulos na data de pagamento, que é a trava do 39094.
		return validarValorDoPagamentoEmMassa(v, this.totalAPagarComDesconto)
	}

	/**
	 * Títulos da seleção que aceitam desconto de juros e multa. A regra é a mesma da baixa
	 * individual: só crediário e boleto de entrada acumulam encargos passíveis de perdão.
	 */
	get titulosSelecionadosComEncargos(): Titulo[] {
		return this.titulosSelecionados
			.map(selecionado => this.titulosCache[selecionado.id])
			.filter(titulo => !!titulo
				&& (titulo.formaDePagamento === 'CREDIARIO' || titulo.formaDePagamento === 'BOLETO')
				&& titulo.fluxo === 'Entrada')
	}

	get podeAplicarDescontoNosEncargos() {
		return this.saldoDeJurosSelecionado > 0 || this.saldoDeMultaSelecionado > 0
	}

	get saldoDeJurosSelecionado() {
		return Number(this.titulosSelecionadosComEncargos.reduce(
			(total, titulo) => total + Number(titulo.jurosRecalculado ?? titulo.juros ?? 0), 0,
		).toFixed(2))
	}

	get saldoDeMultaSelecionado() {
		return Number(this.titulosSelecionadosComEncargos.reduce(
			(total, titulo) => total + Number(titulo.multaRecalculado ?? titulo.multa ?? 0), 0,
		).toFixed(2))
	}

	get saldoDeJurosFormatado() {
		return formatarMoeda(this.saldoDeJurosSelecionado)
	}

	get saldoDeMultaFormatado() {
		return formatarMoeda(this.saldoDeMultaSelecionado)
	}

	/** O desconto em porcentagem é convertido para reais antes de sair da tela. */
	get descontoNosJurosEmReais() {
		if (!this.podeAplicarDescontoNosEncargos) return 0

		if (this.tipoDeDesconto === 'porcentagem') {
			const porcentagem = Math.min(100, Math.max(0, Number(this.valorDeDescontoNosJurosEmPorcentagem || 0)))
			return Number((this.saldoDeJurosSelecionado * porcentagem / 100).toFixed(2))
		}

		return Math.max(0, Number(this.valorDeDescontoNosJuros || 0))
	}

	get descontoNaMultaEmReais() {
		if (!this.podeAplicarDescontoNosEncargos) return 0

		if (this.tipoDeDesconto === 'porcentagem') {
			const porcentagem = Math.min(100, Math.max(0, Number(this.valorDeDescontoNaMultaEmPorcentagem || 0)))
			return Number((this.saldoDeMultaSelecionado * porcentagem / 100).toFixed(2))
		}

		return Math.max(0, Number(this.valorDeDescontoNaMulta || 0))
	}

	get totalDeDescontoNosEncargos() {
		return Number((this.descontoNosJurosEmReais + this.descontoNaMultaEmReais).toFixed(2))
	}

	get totalAPagarComDesconto() {
		return Number(Math.max(0, this.saldoDosTitulosSelecionados - this.totalDeDescontoNosEncargos).toFixed(2))
	}

	// O template só enxerga membro da instância, e formatarMoeda aqui é import do módulo.
	// Chamar formatarMoeda direto do template estoura no render e congela o diálogo, sem que
	// eslint, tsc ou build acusem nada. Por isso a formatação sai por getter, como nos outros
	// campos formatados da tela.
	get totalAPagarComDescontoFormatado() {
		return formatarMoeda(this.totalAPagarComDesconto)
	}

	validarDescontoDeJuros(valorInformado) {
		const desconto = Number(valorInformado || 0)

		if (desconto < 0) return 'O desconto não pode ser negativo'
		if (desconto > this.saldoDeJurosSelecionado) {
			return 'O desconto excede o saldo de juros dos títulos selecionados'
		}

		return true
	}

	validarDescontoDeMulta(valorInformado) {
		const desconto = Number(valorInformado || 0)

		if (desconto < 0) return 'O desconto não pode ser negativo'
		if (desconto > this.saldoDeMultaSelecionado) {
			return 'O desconto excede o saldo de multa dos títulos selecionados'
		}

		return true
	}

	validarDescontoEmPorcentagem(valorInformado) {
		const porcentagem = Number(valorInformado || 0)

		if (porcentagem < 0 || porcentagem > 100) return 'Informe uma porcentagem entre 0 e 100'

		return true
	}

	/**
	 * Perdoar encargo derruba o teto do pagamento. Se o operador já tinha digitado o valor
	 * cheio, ele desce junto em vez de ficar barrado pela validação.
	 */
	@Watch('totalDeDescontoNosEncargos')
	ajustarValorAoTetoComDesconto() {
		if (this.valor === null) return
		if (Number(this.valor) <= this.totalAPagarComDesconto) return

		this.valor = this.totalAPagarComDesconto
	}

	limparDescontos() {
		this.tipoDeDesconto = 'valorFixo'
		this.valorDeDescontoNosJuros = 0
		this.valorDeDescontoNaMulta = 0
		this.valorDeDescontoNosJurosEmPorcentagem = 0
		this.valorDeDescontoNaMultaEmPorcentagem = 0
	}

	get permitirAlterarDataBaixa() {
		return UserLoginStore.permiteRegraDeNegocio('permitir-alteracao-data-pagamento')
	}

	// Saldo que os títulos marcados ainda devem NA DATA DE PAGAMENTO escolhida, que é o teto do
	// que o backend consegue baixar. É o mesmo número que alimenta o campo Saldo Devedor, a base
	// do desconto de encargos e a trava do Valor a Pagar: todos têm que enxergar o mesmo saldo,
	// senão a tela autoriza um valor que o backend não tem onde alocar e a sobra é descartada em
	// silêncio (39094).
	get saldoDosTitulosSelecionados(): number {
		return somarSaldoDosTitulosSelecionados(this.titulosSelecionados)
	}

	get totalSelecionado() {
		return formatarMoeda(this.saldoDosTitulosSelecionados)
	}

	get totalSelecionadoSemJuros() {
		return formatarMoeda(Number.parseFloat(this.titulosSelecionados.reduce((total, titulo) => {
			let valor = parseFloat(titulo.valor.replace(/[^\d,-]/g, '').replace(',', '.'));
			if (isNaN(valor)) {
				valor = 0;
			}
			return total + valor;
		}, 0).toFixed(2)));
	}

	limparSelecao() {
		this.titulosSelecionados = []
		this.idsDeTitulosSelecionados = []
	}

	selecionarTodos() {
		this.titulosSelecionados = this.titulosFormatados
	}

	selecionarVencidos() {
		const hoje = moment().tz('America/Sao_Paulo').format('YYYY-MM-DD')
		const idsVencidos = new Set(
			this.titulos
				// O saldo entra aqui porque esta pré-seleção roda antes de a grid ser filtrada:
				// sem ele, um título vencido e já quitado nascia marcado, ia parar no pagamento
				// e ganhava uma baixa de R$ 0,00.
				.filter(t => t.dataDeVencimento && t.dataDeVencimento <= hoje && this.tituloPagavel(t))
				.map(t => t.id),
		)
		this.titulosSelecionados = this.titulosFormatados.filter(t => idsVencidos.has(t.id))
	}

	// Armadilha: este computed nao e so leitura. Ele chama calcularValorFaltante, que escreve em
	// jurosRecalculado / multaRecalculado / valorRecalculado dos objetos de this.titulos, ou seja,
	// muta estado reativo do qual ele mesmo depende. O
	// @Watch('titulosFormatados', deep) deste arquivo rele o resultado dessa mutacao. Trocar
	// computed por metodo (ou o contrario) muda quando essas escritas acontecem.
	get titulosFormatados() {
		return this.titulos.map(titulo => {
			const maxDescriptionLength = 18
			let descricao = titulo.descricao || ''
			const descricaoCompleta = descricao

			if (descricao.length > maxDescriptionLength) {
				const truncated = descricao.substring(0, maxDescriptionLength);
				const lastSpaceIndex = truncated.lastIndexOf(' ');
				if (lastSpaceIndex > 0) {
					descricao = truncated.substring(0, lastSpaceIndex) + '...';
				} else {
					descricao = truncated + '...';
				}
			}

			const tituloComValorAtualizado = this.calcularValorFaltante(titulo)
			const totalEncargos = (tituloComValorAtualizado.jurosRecalculado || 0) + (tituloComValorAtualizado.multaRecalculado || 0);

			const todasBaixas = titulo.baixaDePagamentoAuditada ?? []
			// Duplicado: o mesmo calculo de ultimaBaixaAtiva existe em NovaTelaDeTitulos.vue. Nao
			// foi unificado porque o outro arquivo esta fora do escopo desta limpeza.
			// Suspeita de defeito, NAO corrigida aqui: no reduce de totalEstornado os juros e a
			// multa vem de `b` (a baixa) e nao de `e` (o estorno), entao o total estornado pode sair
			// maior do que o estorno realmente foi e derrubar a baixa da lista de ativas.
			const ultimaBaixaAtiva = todasBaixas
				.filter(b => b.tipoDeTransacao === 'Baixa' || b.tipoDeTransacao === null)
				.filter(b => {
					const estornosVinculados = todasBaixas.filter(e => e.tipoDeTransacao === 'Estorno' && e.baixaDePagamentoOrigemId === b.id)
					const totalBaixa = Math.abs(b.valorPagamento || 0) + Math.abs(b.valorJurosSobreBaixa || 0) + Math.abs(b.valorDaMultaSobreBaixa || 0)
					const totalEstornado = estornosVinculados.reduce((acc, e) => acc + Math.abs(e.valorPagamento || 0) + Math.abs(b.valorJurosSobreBaixa || 0) + Math.abs(b.valorDaMultaSobreBaixa || 0), 0)
					return totalBaixa - totalEstornado > 0
				})
				.sort((a, b) => new Date(b.dataHoraPagamento).getTime() - new Date(a.dataHoraPagamento).getTime())[0]

			return {
				...tituloComValorAtualizado,
				dataDeVencimento: dateToPtBrFormat(tituloComValorAtualizado.dataDeVencimento),
				dataDeCompetencia: dateToPtBrFormat(tituloComValorAtualizado.dataDeCompetencia),
				descricaoCompleta,
				dataPagamento: ultimaBaixaAtiva ? dateToPtBrFormat(ultimaBaixaAtiva.dataHoraPagamento) : null,
				valor: titulo.valor?.toLocaleString('pt-br', {
					style: 'currency',
					currency: 'BRL',
				}) || '',
				pessoa: titulo.pessoa?.razaoSocialOuNome || '',
				loja: titulo.loja?.nomeFantasia || '',
				formaDePagamento: titulo.formaDePagamento
					? this.displayPagamento(titulo.formaDePagamento)
					: '',
				valorAtualizado: titulo.valorRecalculado?.toLocaleString('pt-br', {
					style: 'currency',
					currency: 'BRL',
				}) || '',
				juros: titulo.jurosRecalculado?.toLocaleString('pt-br', {
					style: 'currency',
					currency: 'BRL',
				}) || '',
				multa: titulo.multaRecalculado?.toLocaleString('pt-br', {
					style: 'currency',
					currency: 'BRL',
				}) || '',
				totalEncargos: totalEncargos.toLocaleString('pt-br', {
					style: 'currency',
					currency: 'BRL',
				}) || '',
				descricao: descricao,
			}

		})
	}

	@Watch('lojaId')
	onLojaIdChange() {
		this.buscar();
	}

	@Watch('usuario')
	onUsuarioChange() {
		this.buscar();
	}

	@Watch('formaDePagamento')
	onFormaDePagamentoChange() {
		this.buscar();
	}

	@Watch('titulosSelecionados')
	onTitulosSelecionadosChange() {
		this.preencherPdvAutomatico();
		this.buscarPdvAberto()
		this.idsDeTitulosSelecionados = this.titulosSelecionados
			.map(titulo => titulo.id)
			.filter(id => !this.idsDeTitulosSelecionados.includes(id))
			.concat(this.idsDeTitulosSelecionados);
	}

	@Watch('paginacao')
	async buscar() {
		try {
			if(!this.usuario?.id && !this.clienteAdquirente) return
			if(!this.lojaId) return
			this.carregando = true;

			if(this.titulos.length > 0 && this.titulosFiltradoDaTelaPrincipal) {
				await this.carregarBaixasAuditadas(this.titulos)
				
				
				// O cache é alimentado ANTES do filtro, de propósito: é ele que
				// atualizarTitulosSelecionados consulta para saber se um título ainda tem saldo.
				// Se só os sobreviventes fossem cacheados, o título recém quitado ficaria com o
				// valor antigo no cache e continuaria parecendo pagável.
				this.titulos.forEach(titulo => { this.titulosCache[titulo.id] = titulo })
				this.titulos = this.titulos.filter(titulo => this.tituloPagavel(titulo));

				this.totalRegistros = this.titulos.length

				await this.$nextTick()
				this.atualizarTitulosSelecionados(this.titulosSelecionados)
				this.titulosFiltradoDaTelaPrincipal = false
				return
			}
			
			this.limparSelecao()
			const isTodos = this.paginacao.itemsPerPage === -1
			const size = isTodos
				? (this.totalRegistros > 0 ? this.totalRegistros : 99999)
				: this.paginacao.itemsPerPage

			const page = await this.findTituloUseCase.findParaBaixa({
				lojaId: this.lojaId,
				clienteId: this.usuario?.id,
				formaDePagamento: this.formaDePagamento,
				clienteAdquirente: this.clienteAdquirente,
				page: isTodos ? 0 : this.paginacao.page - 1,
				size,
			})

			await this.carregarBaixasAuditadas(page.content)


			page.content.forEach(titulo => { this.titulosCache[titulo.id] = titulo })
			this.titulos = page.content.filter(titulo => this.tituloPagavel(titulo));

			this.totalRegistros = page.totalElements

			await this.$nextTick()
			this.atualizarTitulosSelecionados(this.titulosSelecionados)
		} catch (e) {
			AlertModule.setError(e)
			this.carregando = false;
		} finally {
			this.carregando = false;
		}
	}

	// Bloco que estava duplicado byte a byte nos dois caminhos de buscar(). Continua sendo uma
	// requisicao por titulo (N+1), todas disparadas em paralelo, igual antes. Nao e async de
	// proposito: devolvendo o proprio Promise.all, o await do chamador espera exatamente o que
	// esperava antes.
	carregarBaixasAuditadas(titulos: Titulo[]) {
		return Promise.all(titulos.map(async titulo => {
			const params = {
				tituloId: titulo.id,
			}

			const baixasDoTitulo = await this.findBaixaDePagamentoUseCase.findByTituloId(
				params,
			)

			titulo.baixaDePagamentoAuditada = baixasDoTitulo.content
		}))
	}

	atualizarTitulosSelecionados(titulosSelecionadosAnteriores: any[]) {
		// Consulta o título BRUTO do cache, e não o item preservado: o preservado é o formatado,
		// cujo valorAtualizado já é string ("R$ 0,00"). Título desconhecido do cache é mantido,
		// para não descartar seleção de outra página.
		const aindaEhPagavel = (id: string) => {
			const bruto = this.titulosCache[id]
			return !bruto || this.tituloPagavel(bruto)
		}

		// Um título quitado tem que sumir também da lista de ids, senão volta a ser marcado na
		// próxima busca.
		this.idsDeTitulosSelecionados = this.idsDeTitulosSelecionados.filter(aindaEhPagavel);

		// Preservar quem não está na grid é o que mantém a seleção entre páginas, mas sem o
		// teste de saldo isso ressuscitava justamente o título que o filtro acabou de remover
		// por estar quitado. Ele voltava para a lista de selecionados, somava no Valor Original
		// e ia no pagamento, onde recebia uma baixa de R$ 0,00.
		const titulosAnteriores = titulosSelecionadosAnteriores.filter(titulo =>
			this.idsDeTitulosSelecionados.includes(titulo.id) &&
			aindaEhPagavel(titulo.id) &&
			!this.titulos.some(t => t.id === titulo.id),
		);

		const titulosNovosParaSelecionar = this.titulosFormatados.filter(titulo =>
			this.idsDeTitulosSelecionados.includes(titulo.id),
		);

		this.titulosSelecionados = [...titulosAnteriores, ...titulosNovosParaSelecionar];
	}

	async salvar() {
		if (!this.form.validate()) return
		if (!this.baixaDePagamento) return

		try {
			this.salvando = true
			const titulosSelecionadosOriginais = this.titulosSelecionados.map(selecionado => {
				const titulo = this.titulosCache[selecionado.id]
				if (!titulo) {
					throw new Error(`Titulo com ID ${selecionado.id} não encontrado.`)
				}

				const tituloAtualizado = this.calcularValorFaltante(titulo)
				
				return {
					...titulo,
					// O recalculado só existe para crediário; no boleto o encargo é o que veio
					// do banco, e é sobre ele que o desconto tem que incidir.
					juros: tituloAtualizado.jurosRecalculado ?? titulo.juros,
					multa: tituloAtualizado.multaRecalculado ?? titulo.multa,
					valorAtualizado: tituloAtualizado.valorRecalculado,
					recalculado: true,
				}
			})

			this.baixaDePagamento.titulo = titulosSelecionadosOriginais;
			this.baixaDePagamento.valorPagamento = !this.valor ? 0 : this.valor
			this.baixaDePagamento.formaDePagamento = this.formaDePagamamentoParaPagar
			this.baixaDePagamento.transactionId = ''
			this.baixaDePagamento.tipoDeTransacao = TipoDeTransacaoDaBaixaDePagamento.BAIXA
			this.baixaDePagamento.valorDeDescontoNosJuros = this.descontoNosJurosEmReais
			this.baixaDePagamento.valorDeDescontoNaMulta = this.descontoNaMultaEmReais
			this.baixaDePagamento.tipoDeDesconto = this.totalDeDescontoNosEncargos > 0
				? this.tipoDeDesconto
				: 'semDesconto'
			const horaFormatada = new Date().toLocaleTimeString('pt-BR')
			this.baixaDePagamento.dataHoraPagamento = `${this.data}T${horaFormatada}`
			const comprovanteDasBaixas = await this.createBaixaUseCase.createMultiplo(this.baixaDePagamento)
			await imprimirComprovanteDeRecebivel(comprovanteDasBaixas)
			this.$emit('atualizar')
			this.esconder()
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
			this.mostra = false
		}
	}

	formatarNumero(numero) {
		const numeroFormatado = numero.toLocaleString('pt-BR', {
			style: 'currency',
			currency: 'BRL',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		});
		return numeroFormatado;
	}

	@Watch('tipoDePessoa')
	onTipoDePessoaChange() {
		if (this.tipoDePessoa === 'adquirente'){
			this.usuario = null
		} else {
			this.clienteAdquirente = null
		}

		this.buscar()
	}

	@Watch('clienteAdquirente')
	onClienteAdquirenteChange() {
		this.buscar();
	}

}
